import { getLanguage } from '@/utils/language'

/** Ошибка бэка бывает объектом с локализованным сообщением. */
interface LocalizedMessage {
  ru?: string
  en?: string
  uz?: string
}

interface BackendError {
  message?: string | LocalizedMessage
}

/** Ответ с ошибкой в теле при HTTP 200 — бэкенд так умеет. */
export interface MaybeErrorBody {
  error?: string | BackendError
  data?: { error?: string | BackendError }
}

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    /** Ошибка пришла в теле успешного ответа, а не HTTP-кодом */
    readonly inBody = false,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

/**
 * Бэкенд отдаёт ошибку в трёх форматах: строкой в теле, `error` строкой
 * и `error.message` объектом локалей. Разбираем все три (перенос из useApi).
 */
export function extractError(body: unknown): string | null {
  if (typeof body === 'string') return body || null
  if (!body || typeof body !== 'object') return null

  const source = body as MaybeErrorBody
  const error = source.error ?? source.data?.error
  if (!error) return null

  if (typeof error === 'string') return error

  const { message } = error
  if (typeof message === 'string') return message
  if (message && typeof message === 'object') {
    return message[getLanguage()] ?? message.ru ?? null
  }
  return null
}
